import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const processDiscoveryRulesDetailGridColumns = () => [
    {
        field: 'discovery_rule_id',
        headerName: 'DiscoveryRule ID',
        hide: true,
    },
    {
        field: 'category',
        headerName: 'Category',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        width: 160,
    },
    {
        field: 'sub_discovery_rule',
        headerName: 'DiscoveryRule',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        minWidth:250,
        flex: 1,
        cellRenderer: 'agGroupCellRenderer',
    },
    {
        field: 'type',
        headerName: 'Type',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        width: 120,
    },
    {
        field: 'automation_opportunity',
        headerName: 'Automation Opportunity',
        filter: true,
        hide: false,
        width: 140,
    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 90,
        hide: false,
        type: 'rightAligned',
        valueFormatter: ({ value }) => numberWithCommas(value),
    },    
    {
        field: 'percTasks',
        headerName: '% ' + apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 90,
        hide: false,
        type: 'rightAligned',
        valueFormatter: ({ value }) => formatPercentage(value,1),
    },    
    {
        field: 'events',
        headerName: 'Events',
        filter: 'agNumberColumnFilter',
        width: 90,
        hide: true,
        type: 'rightAligned',
        valueFormatter: ({ value }) => numberWithCommas(value),
    },  
    {
        field: 'percEvents',
        headerName: '% Events',
        filter: 'agNumberColumnFilter',
        width: 90,
        hide: true,
        type: 'rightAligned',
        valueFormatter: ({ value }) => formatPercentage(value,1),
    },        
    {
        field: 'avgImpactDurationTasks',
        headerName: 'Avg Impact Duration (Issues)',
        filter: 'agNumberColumnFilter',
        width: 150,
        hide: false,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'avgImpactDurationEvents',
        headerName: 'Avg Impact Duration (Events)',
        filter: 'agNumberColumnFilter',
        width: 150,
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'totalImpactDuration',
        headerName: 'Total Impact Duration',
        filter: 'agNumberColumnFilter',
        width: 150,
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },    
    {
        field: 'calculate_cost_impact',
        headerName: 'Calculate Cost Impact',
        filter: true,
        hide: true,
        width: 140,
    },

    {
        field: 'actual_cost',
        headerName: 'Actual Cost',
        hide: false,
        width: 100,
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'forecast_cost',
        headerName: 'Forecast Cost',
        hide: false,
        width: 100,
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'cost_saving',
        headerName: 'Cost Saving',
        hide: true,
        width: 100,
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatCost({ cost: value  }),
    },
    {
        field: 'perc_cost_saving',
        headerName: '% Cost Saving',
        hide: false,
        width: 100,
        aggFunc: 'sum',
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            formatPercentage( value, 2 ),
    },
    {
        field: 'id',
        headerName: 'ID',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'save_activities',
        headerName: 'save_activities',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'save_steps',
        headerName: 'save_steps',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'save_variants',
        headerName: 'save_variants',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'filter_activities',
        headerName: 'filter_activities',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'filter_variants',
        headerName: 'filter_variants',
        hide: true,
        suppressColumnsToolPanel: true
    },
    {
        field: 'filter_steps',
        headerName: 'filter_steps',
        hide: true,
        suppressColumnsToolPanel: true
    },

];

export function numberWithCommas(x) {
    if (x === -1) return ''
    return Number(x).toLocaleString()
}

export function formatPercentage(x, decimals) {
    if (x === -1) return ''
    else return (x * 100).toFixed(decimals) + '%';
}

